import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

export default {
    namespaced: true,
    state: {
        pages: [],
        actualPage: [],
        pagesKeys: []
    },

    mutations: {
        SET_PAGES(state, payload) {
            state.pages = payload;
        },

        SET_ACTUAL_PAGE(state, payload) {
            state.actualPage = payload;
        },

        SET_PAGES_KEYS(state, payload) {
            state.pagesKeys = payload;
        },
    },

    actions: {
        async fetchPages({ commit }) {
            try {
                let transformedData;

                const response = await axios.get(
                    `${baseUrl}/pages/getPages`,
                    {
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.page_id,
                            'URL': obj.page_url,
                            'Заголовок': obj.page_header,
                            'Текст': obj.page_description,
                            'Краткий текст': obj.page_description.length > 200 ? `${obj.page_description.substring(0, 200)}…` : obj.page_description,
                            'Автор': obj.user_fullname,
                            'Email': obj.user_email,
                            'Дата создания': obj.page_create_date,
                            'Тип': obj.page_type,
                            'Статус': obj.page_status
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PAGES', transformedData); // сохраняем данные в состояние

                commit('SET_PAGES_KEYS', {
                    'Заголовок': "headerText",
                    'URL': "pageUrl",
                    'Текст': "descriptionText",
                    'Автор': "authorEmail",
                    'Тип': "pageType",
                    'Статус': "statusName"
                });
            } catch (error) {
                console.error(error);
            }
        },

        async fetchActualPage({ commit }, params) {
            try {
                let transformedData;

                const response = await axios.post(
                    `${baseUrl}/pages/getActualPage`, params, config
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.page_id,
                            'URL': obj.page_url,
                            'Заголовок': obj.page_header,
                            'Текст': obj.page_description,
                            'Автор': obj.user_fullname,
                            'Email': obj.user_email,
                            'Дата создания': obj.page_create_date,
                            'Тип': obj.page_type,
                            'Статус': obj.page_status
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ACTUAL_PAGE', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        }
    }
}